import { responseValidator } from './responseValidator';

export const TryCatchGeneric = async (fetchFunction, setStatusService, setIsLoading, failedService) => {
    try {
        const response = await fetchFunction();
        responseValidator({ response }, setStatusService, setIsLoading);
    } catch (error) {
        failedService();
        responseValidator({ error }, setStatusService, setIsLoading);
    }
};